import React from 'react'
import Avatar from './avatar'

class AvatarList extends React.Component {
    constructor(props){
        super(props)
    }

    render() {
        const { teamMembers, onClick, onCounterClick } = this.props
        const tooMany = teamMembers.length > 6
        
        return (
            <div className="btn-avatar team-sidebar-avatar">
                {teamMembers.map((member, index) => {
                    if (teamMembers.length < 7) {
                        return <Avatar key={index} emailAddress={member.email} name={member.name} showTooltip={true} onClick={onClick}/>
                    } else {
                        if (index < 5) {
                            return <Avatar key={index} emailAddress={member.email} name={member.name} showTooltip={true} onClick={onClick} />
                        }
                        return
                    }
                })
                }
                {tooMany && (
                    <Avatar
                        emailAddress={`+${teamMembers.length - 5}`}
                        name={undefined}
                        isCounter={true}
                        showTooltip={true}
                        tooltipText="Manage members"
                        onClick={onCounterClick}/>
                )}
            </div>
        )
    }
}

export default AvatarList


// WEBPACK FOOTER //
// ./src/components/avatar_list.jsx